import { queryKey } from 'Shared/const/queryKey';
import { Box, Column, Row, Spinner, Typography } from '@viewup/ui';
import { useSDQuery } from 'viewup-lib/react';
import { exchangeRankingImage, rankOrderMap } from '../../model/const';

export const MonthlyRankingIntro = () => {
  const { data: getRankingMonth, isPending } = useSDQuery({
    ...queryKey.point.rankingMonth,
  });

  if (isPending) {
    return (
      <Row alignItems='center' justifyContent='center' minHeight={192} mt={32}>
        <Spinner color='system.white' variant='round' />
      </Row>
    );
  }

  if (!getRankingMonth?.length) {
    return (
      <Row alignItems='center' justifyContent='center' minHeight={192} mt={32}>
        <Typography color='system.white' fontType='body2.regular'>
          집계 중이에요. 조금만 기다려주세요!
        </Typography>
      </Row>
    );
  }

  return (
    <Row gap={12} mt={32}>
      {getRankingMonth?.slice(0, 3).map((rank) => (
        <Column
          alignItems='center'
          bgColor='bg.primary'
          border='1 solid border.tertiary'
          br={12}
          css={{ order: rankOrderMap[rank.pointRank] }}
          gap={16}
          key={rank.nickname}
          mb={rank.pointRank === 1 ? 16 : 0}
          mt={rank.pointRank !== 1 ? 16 : 0}
          position='relative'
          px={12}
          py={16}
          shadow='center.normal'
          width='100%'
        >
          <Box css={{ top: rank.pointRank === 1 ? '-34px' : '-25px' }} position='absolute'>
            {exchangeRankingImage(rank.pointRank)?.trophy}
          </Box>
          {exchangeRankingImage(rank.pointRank)?.char}
          <Column alignItems='center' css={{ textAlign: 'center' }} gap={4}>
            <Typography fontType='body2.medium'>
              {Number(rank.pointsEarned).toLocaleString()}P
            </Typography>
            <Typography color='text.assistance' ellipsisLine={1} fontType='caption2.regular'>
              {rank.nickname}
            </Typography>
          </Column>
        </Column>
      ))}
    </Row>
  );
};
